import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { IntegracaoService } from 'src/app/services/integracao.service';
import { AssinaturaService } from './services/assinatura.service';
@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor (
    private titleService: Title, 
    private router: Router,
    private assinaturaService: AssinaturaService
  ) {
    let urlParametros= window.location.href.toString().split('/?code=')[1];
    console.log(urlParametros);
    
    this.getParametrosAssinaturaComunicado();
    try{
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if((<any>window).ga !== undefined){
            (<any>window).ga('set', 'page', event.urlAfterRedirects);
            (<any>window).ga('send', 'pageview');
          }
        }
      });
    }catch(e){
      console.log('erro ao enviar analytics', e);
    }
  }

  getParametrosAssinaturaComunicado() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code && window.opener) {
      window.opener.postMessage({ code }, 'https://dec.sefaz.to.gov.br');
      window.close();
    }

    window.addEventListener('message', (event) => {
        if (event.origin !== 'https://dec.sefaz.to.gov.br') return;
      const code = event.data.code;
      
      if (code) {
        this.assinaturaService.atualizarCodeAssinatura(code);
      }
    })
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle('front-dte-v2')
  }
}
